import {
  roles,
  paymentOfCreditCard,
  paymentOfOthers,
  physicalProductOrderStatusTextTranslation,
  transactionTypes,
  positions,
  leaveApplicationType,
  leaveApplicationActionStatus,
  serviceProductServiceType,
  serviceProductServiceTypeEmojiHashMap,
  tableManagementStatus,
  tableManagementType,
  tableApplicationStatus,
  tableManagementGenderPreference,
  tableManagementAgeRangePreference,
  tableManagementHeightRangePreference,
  tableManagementMBTIPreference,
  tableManagementPaymentType,
  profileGender,
  profileGenderPreference,
  subscriptionPlanStatus,
  subscriptionPlanPaymentStatus,
  billingStatus,
  notificationType,
  activityLogStatus,
  paymentStatus,
  tableManagementActivityType,
  billingProductType,
  lpmsFileTypes,
  lpmsState,
  crmOptionsSubTypes,
  rnTypes,
  insuranceTypes,
} from '@/data/constants';
import moment from 'moment';

export const roleOptions = [
  {
    label: 'Admin',
    value: roles.admin,
  },
  {
    label: 'Customer',
    value: roles.client,
  },
  {
    label: 'Therapist',
    value: roles.master,
  },
  {
    label: 'Cashier',
    value: roles.cashier,
  },
];

export const paymentOfCreditCardOptions = [
  {
    label: 'Visa/Master',
    value: paymentOfCreditCard.visaOrMaster,
  },
  {
    label: 'AE',
    value: paymentOfCreditCard.ae,
  },
  // {
  //   label: 'Master',
  //   value: paymentOfCreditCard.master,
  // },
  {
    label: 'Union Pay',
    value: paymentOfCreditCard.unionPay,
  },
];

export const paymentOfOthersOptions = [
  {
    label: 'Cash',
    value: paymentOfOthers.cash,
  },
  {
    label: 'Octopus Card',
    value: paymentOfOthers.octopusCard,
  },
  {
    label: 'Alipay HK',
    value: paymentOfOthers.alipayHK,
  },
  {
    label: 'Payme',
    value: paymentOfOthers.payMe,
  },
  {
    label: 'WeChat',
    value: paymentOfOthers.weChat,
  },
  {
    label: 'Online Pay',
    value: paymentOfOthers.onlinePay,
  },
  {
    label: 'Paypal',
    value: paymentOfOthers.payPal,
  },
  {
    label: 'Cheque',
    value: paymentOfOthers.cheque,
  },
  {
    label: 'Bank Transfer',
    value: paymentOfOthers.bankTransfer,
  },
];

export const colorOption = [
  // Color Should Different
  { value: `ffffff`, label: 'Oil', description: `Oil` },
  { value: `f79433`, label: 'DO', description: `Dark Orange` },
  { value: `b41343`, label: 'DR', description: `Dark Red` },
  { value: `a96e46`, label: 'B', description: `Brown` },
  { value: `9a4724`, label: 'CO', description: `COCO` },
  { value: `974031`, label: 'CH', description: `Chestnut` },
  { value: `452e1f`, label: 'DB', description: `Dark Brown` },
  { value: `613b57`, label: 'DP', description: `Indigo` },
  { value: `811141`, label: 'RB', description: `Rose Brown` },
  { value: `c7c8ca`, label: 'HT', description: `Hair Mask` },
  { value: `8b0029`, label: 'WR', description: `Wine Red` },
  { value: `e2c321`, label: 'GO', description: `Gold` },
];
export const doseOption = [
  '0.5',
  '1',
  '1.5',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  // Color Should Different
];
export const durationOption = [
  '5',
  '10',
  '15',
  '20',
  '25',
  '30',
  '35',
  '40',
  '45',
  '50',
  '55',
  '60',
];

export const durationOption2 = [
  'Only 1 Round',
  '5',
  '10',
  '15',
  '20',
  '25',
  '30',
  '35',
  '40',
  '45',
  '50',
  '55',
  '60',
];

export const scalpSituationOption = [
  'Normal',
  'Hair Loss',
  'Sensitive / Red',
  'Dandruff',
  'Acne',
  'Itchy',
  'Eczema',
  'G6PD',
  'Other',
];
export const hairThicknessOption = [
  '銀離子染髮',
  'Red permanent dye / chinese dye',
  'Black permanent dye / chinese dye',
  'Chemical semi permanent',
  'Chemical light color',
  'Perm',
  'Other',
];
export const hairVolumeOption = ['Thick', 'Normal', 'Thin'];
export const hairConditionOption = [
  'Oily',
  'Normal',
  'Dry',
  'Frizzy',
  'Hair Loss',
  'Highlighted',
  'Chemical Dye',
  'Permed',
];
export const expectedColorResultOption = [
  'Dark Orange',
  'Dark Red',
  'Coco',
  'Chestnut',
  'Light Brown',
  'Dark Brown',
  'Black as possible',
  'Other',
];
export const bookingStatusOption = [
  { value: '0$created', label: 'New Booking' },
  { value: '1$arrived', label: 'Arrived' },
  { value: '98$absent', label: 'Absent' },
  { value: '99$completed', label: 'Completed' },
  { value: '97$cancelled', label: 'Cancelled' },
];

export const districts = [
  'Central and Western',
  'Eastern',
  'Southern',
  'Wan Chai',
  'Kowloon City',
  'Kwun Tong',
  'Sham Shui Po',
  'Wong Tai Sin',
  'Yau Tsim Mong',
  'Islands',
  'Kwai Tsing',
  'North',
  'Sai Kung',
  'Sha Tin',
  'Tai Po',
  'Tsuen Wan',
  'Tuen Mun',
  'Yuen Long',
];

export const month = [
  { text: 'January', value: '01' },
  { text: 'February', value: '02' },
  { text: 'March', value: '03' },
  { text: 'April', value: '04' },
  { text: 'May', value: '05' },
  { text: 'June', value: '06' },
  { text: 'July', value: '07' },
  { text: 'August', value: '08' },
  { text: 'September', value: '09' },
  { text: 'October', value: '10' },
  { text: 'November', value: '11' },
  { text: 'December', value: '12' },
];

export const years = Array.from({ length: 20 }, (_, i) => String(2022 + i));

export const bookingSortOption = [
  { value: { '_timetableTime.start': -1 }, label: 'By Service Time' },
  { value: { created_at: -1 }, label: 'By Booking Time' },
];

export const time = Array.from({ length: 48 }, (_, i) =>
  moment()
    .startOf('d')
    .add(i * 30, 'minutes')
    .format('HH:mm'),
);

export const leaveTypeOption = [
  { text: 'Sick Leave', value: 'SL' },
  { text: 'Annual Leave', value: 'AL' },
  { text: 'No Pay Leave', value: 'NPL' },
  { text: 'Compensatory Leave', value: 'CL' },
  { text: 'Absent', value: 'Absent' },
  { text: 'Other', value: 'Other' },
];

// for leaveAction = leaveApplication
export const leaveActionApplicationOption = [
  { text: 'Annual Leave', value: leaveApplicationType.annualLeave },
  { text: 'Sick Leave', value: leaveApplicationType.sickLeave },
  { text: 'Family Holiday', value: leaveApplicationType.familyHoliday },
  { text: 'No Pay Leave', value: leaveApplicationType.noPayLeave },
  { text: 'Compensatory Leave', value: leaveApplicationType.compensatoryLeave },
  { text: 'Other', value: leaveApplicationType.otherLeave },
];

// for leaveAction = leaveAdjustment
export const leaveActionAdjustmentOption = [
  { text: 'Annual Leave', value: leaveApplicationType.annualLeave },
  { text: 'Compensatory Leave', value: leaveApplicationType.compensatoryLeave },
  { text: 'Other', value: leaveApplicationType.otherLeave },
];

export const leaveApplicationStatusOption = [
  { value: '0$pending', label: 'Pending' },
  { value: '1$approved', label: 'Approved' },
  { value: '99$rejected', label: 'Rejected' },
];

export const leaveActionOption = [
  {
    value: leaveApplicationActionStatus.leaveApplication,
    text: 'Leave Application',
  },
  {
    value: leaveApplicationActionStatus.absent,
    text: 'Absent',
  },
  {
    value: leaveApplicationActionStatus.leaveAdjustment,
    text: 'Leave Adjustment',
  },
];

export const physicalProductOrderStatusOption = [
  { value: '0$pendingPayment', text: physicalProductOrderStatusTextTranslation.pendingPayment },
  { value: '1$pendingDelivery', text: physicalProductOrderStatusTextTranslation.pendingDelivery },
  { value: '99$completed', text: physicalProductOrderStatusTextTranslation.completed },
  { value: '98$cancelled', text: physicalProductOrderStatusTextTranslation.cancelled },
  { value: '97$expired', text: physicalProductOrderStatusTextTranslation.expired },
];

export const physicalProductOrderPaymentStatusOption = [
  { text: 'Pending', value: 'pending' },
  { text: 'Paid', value: 'paid' },
  { text: 'Fail', value: 'fail' },
];

export const transactionOption = [
  {
    value: transactionTypes.TicketsPackage,
    text: 'Ticket Purchase',
  },
  {
    value: transactionTypes.Booking,
    text: 'Service',
  },
  {
    value: transactionTypes.Redo,
    text: 'Redo',
  },
  {
    value: transactionTypes.PhysicalProductOrder,
    text: 'Product Walkin',
  },
  // {
  //   value: transactionTypes.PayrollRecord,
  //   text: 'Payroll',
  // },
  {
    value: transactionTypes.computedOnlineOrder,
    text: 'Product Online',
  },
  {
    value: transactionTypes.computedProductInService,
    text: 'Product in Service',
  },
  {
    value: transactionTypes.computedServiceOnly,
    text: 'Service Only',
  },
];

export const serviceProductServiceTypeOption = [
  {
    value: serviceProductServiceType.N,
    text: 'Hair Color',
    abbreviation: 'Color',
    icon: serviceProductServiceTypeEmojiHashMap[serviceProductServiceType.N],
  },
  {
    value: serviceProductServiceType.HG,
    text: 'Hair Growth',
    abbreviation: 'HG',
    icon: serviceProductServiceTypeEmojiHashMap[serviceProductServiceType.HG],
  },
  {
    value: serviceProductServiceType.HL,
    text: 'Highlight',
    abbreviation: 'HL',
    icon: serviceProductServiceTypeEmojiHashMap[serviceProductServiceType.HL],
  },
  {
    value: serviceProductServiceType.Other,
    text: 'Other',
    abbreviation: 'Other',
    icon: serviceProductServiceTypeEmojiHashMap[serviceProductServiceType.Other],
  },
];

export const positionOption = Object.entries(positions).map(([key, value]) => {
  return {
    text: value,
    value: key,
  };
});

// Table Management Options
export const tableManagementStatusOption = [
  { value: tableManagementStatus.pending, text: 'Pending' },
  { value: tableManagementStatus.matched, text: 'Matched' },
  { value: tableManagementStatus.completed, text: 'Completed' },
  { value: tableManagementStatus.cancelled, text: 'Cancelled' },
  { value: tableManagementStatus.expired, text: 'Expired' },
];

export const tableManagementTypeOption = [
  { value: tableManagementType.free, text: 'Free' },
  { value: tableManagementType.paid, text: 'Paid' },
  { value: tableManagementType.premium, text: 'Premium' },
];

export const tableManagementGenderPreferenceOption = [
  { value: tableManagementGenderPreference.male, text: 'Male' },
  { value: tableManagementGenderPreference.female, text: 'Female' },
  { value: tableManagementGenderPreference.both, text: 'Both' },
];

export const tableManagementAgeRangePreferenceOption = [
  { value: tableManagementAgeRangePreference.nonSupport, text: 'No Preference' },
  { value: tableManagementAgeRangePreference['18-23'], text: '18-23' },
  { value: tableManagementAgeRangePreference['24-30'], text: '24-30' },
  { value: tableManagementAgeRangePreference['31-40'], text: '31-40' },
  { value: tableManagementAgeRangePreference['41-99'], text: '41-99' },
];

export const tableManagementHeightRangePreferenceOption = [
  { value: tableManagementHeightRangePreference.nonSupport, text: 'No Preference' },
  { value: tableManagementHeightRangePreference['0-159'], text: '0-159 cm' },
  { value: tableManagementHeightRangePreference['160-165'], text: '160-165 cm' },
  { value: tableManagementHeightRangePreference['166-170'], text: '166-170 cm' },
  { value: tableManagementHeightRangePreference['171-250'], text: '171-250 cm' },
];

export const tableManagementMBTIPreferenceOption = [
  { value: tableManagementMBTIPreference.nonSupport, text: 'No Preference' },
  { value: tableManagementMBTIPreference.extrovert, text: 'Extrovert' },
  { value: tableManagementMBTIPreference.introvert, text: 'Introvert' },
  { value: tableManagementMBTIPreference.neutral, text: 'Neutral' },
  { value: tableManagementMBTIPreference.unknown, text: 'Unknown' },
];

export const tableManagementPaymentTypeOption = [
  { value: tableManagementPaymentType.nonSupport, text: 'No Preference' },
  { value: tableManagementPaymentType.full, text: 'My Treat' },
  { value: tableManagementPaymentType.splitBill, text: 'Split Bill' },
  { value: tableManagementPaymentType.joinerPay, text: 'Joiner Pays' },
];

export const profileGenderOption = [
  { value: profileGender.male, text: 'Male' },
  { value: profileGender.female, text: 'Female' },
  // { value: profileGender.unknown, text: 'Unknown' },
  // { value: profileGender.nonBinary, text: 'Non-Binary' },
];

export const profileGenderPreferenceOption = [
  { value: profileGenderPreference.male, text: 'Male' },
  { value: profileGenderPreference.female, text: 'Female' },
  { value: profileGenderPreference.both, text: 'Everyone' },
];

// Table Application Options
export const tableApplicationStatusOption = [
  { value: tableApplicationStatus.pending, text: 'Pending' },
  { value: tableApplicationStatus.matched, text: 'Matched' },
  { value: tableApplicationStatus.completed, text: 'Completed' },
  { value: tableApplicationStatus.cancelled, text: 'Cancelled' },
  { value: tableApplicationStatus.expired, text: 'Expired' },
];

export const educationOptions = [
  { value: 'secondary', label: 'Secondary school', emoji: '🎒' },
  { value: 'associate', label: 'Associate degree', emoji: '📚' },
  { value: 'degree', label: "Bachelor's or higher", emoji: '🎓' },
];

export const relationshipTypeOptions = [
  { value: 'serious', label: 'Serious relationship', emoji: '💍' },
  { value: 'casual', label: 'Casual dating', emoji: '😊' },
  { value: 'marriage', label: 'Looking for marriage', emoji: '👰‍♀️' },
  { value: 'friends', label: 'New friends', emoji: '🤝' },
  { value: 'diningPartner', label: 'Dining Partner', emoji: '🍽' },
  { value: 'notSure', label: 'Not sure', emoji: '🤷‍♂️' },
];

export const languageOptions = [
  { value: 'cantonese', label: 'Cantonese', emoji: '🗣️' },
  { value: 'english', label: 'English', emoji: '🇬🇧' },
  { value: 'mandarin', label: 'Mandarin', emoji: '🇨🇳' },
];

export const foodOptions = [
  { value: 'italian', label: 'Italian', emoji: '🍝' },
  { value: 'chinese', label: 'Chinese', emoji: '🥢' },
  { value: 'japanese', label: 'Japanese', emoji: '🍣' },
  { value: 'korean', label: 'Korean', emoji: '🥘' },
  { value: 'thai', label: 'Thai', emoji: '🍜' },
  { value: 'indian', label: 'Indian', emoji: '🍛' },
  { value: 'mexican', label: 'Mexican', emoji: '🌮' },
  { value: 'american', label: 'American', emoji: '🍔' },
  { value: 'french', label: 'French', emoji: '🥐' },
  { value: 'mediterranean', label: 'Mediterranean', emoji: '🫒' },
  { value: 'middle-eastern', label: 'Middle Eastern', emoji: '🥙' },
  { value: 'vietnamese', label: 'Vietnamese', emoji: '🍲' },
  { value: 'seafood', label: 'Seafood', emoji: '🦐' },
  { value: 'steakhouse', label: 'Steakhouse', emoji: '🥩' },
  { value: 'bbq', label: 'BBQ', emoji: '🍖' },
  { value: 'pizza', label: 'Pizza', emoji: '🍕' },
  { value: 'vegetarian', label: 'Vegetarian', emoji: '🥗' },
  { value: 'vegan', label: 'Vegan', emoji: '🌱' },
  { value: 'desserts', label: 'Desserts', emoji: '🍰' },
  { value: 'coffee', label: 'Coffee & Pastries', emoji: '☕' },
  { value: 'brunch', label: 'Brunch', emoji: '🥞' },
  { value: 'street-food', label: 'Street Food', emoji: '🌭' },
  { value: 'fine-dining', label: 'Fine Dining', emoji: '🍽️' },
  { value: 'casual-dining', label: 'Casual Dining', emoji: '🍴' },
];

export const activityOptions = [
  { value: 'Foodie', label: 'Foodie', emoji: '🍜' },
  { value: 'Travel', label: 'Travel', emoji: '✈️' },
  { value: 'Music', label: 'Music', emoji: '🎵' },
  { value: 'Movies', label: 'Movies', emoji: '🎬' },
  { value: 'Fitness', label: 'Fitness', emoji: '💪' },
  { value: 'Art', label: 'Art', emoji: '🎨' },
  { value: 'Books', label: 'Books', emoji: '📚' },
  { value: 'Gaming', label: 'Gaming', emoji: '🎮' },
  { value: 'Photography', label: 'Photography', emoji: '📸' },
  { value: 'Cooking', label: 'Cooking', emoji: '👨‍🍳' },
  { value: 'Dancing', label: 'Dancing', emoji: '💃' },
  { value: 'Wine', label: 'Wine', emoji: '🍷' },
  { value: 'Coffee', label: 'Coffee', emoji: '☕' },
  { value: 'Beach', label: 'Beach', emoji: '🏖️' },
];

export const dateActivityOptions = [
  { value: 'Fine Dining', label: 'Fine Dining', emoji: '🍽️' },
  { value: 'Casual Eats', label: 'Casual Eats', emoji: '🍔' },
  { value: 'Drinks & Cocktails', label: 'Drinks & Cocktails', emoji: '🍸' },
  { value: 'Coffee Dates', label: 'Coffee Dates', emoji: '☕' },
  { value: 'Cinema', label: 'Cinema', emoji: '🎬' },
  { value: 'Live Music', label: 'Live Music', emoji: '🎵' },
  { value: 'Museums & Art', label: 'Museums & Art', emoji: '🎨' },
  { value: 'Shopping', label: 'Shopping', emoji: '🛍️' },
  { value: 'Parks & Nature', label: 'Parks & Nature', emoji: '🌳' },
  { value: 'Sports Events', label: 'Sports Events', emoji: '⚽' },
  { value: 'Gaming Cafes', label: 'Gaming Cafes', emoji: '🎮' },
  { value: 'Karaoke', label: 'Karaoke', emoji: '🎤' },
  { value: 'Dancing', label: 'Dancing', emoji: '💃' },
  { value: 'Hiking & Trails', label: 'Hiking & Trails', emoji: '🥾' },
];

export const mbtiOptions = [
  'INTJ',
  'INTP',
  'ENTJ',
  'ENTP',
  'INFJ',
  'INFP',
  'ENFJ',
  'ENFP',
  'ISTJ',
  'ISFJ',
  'ESTJ',
  'ESFJ',
  'ISTP',
  'ISFP',
  'ESTP',
  'ESFP',
];

export const districtsOptions = [
  {
    label: 'Central and Western District',
    value: 'Central and Western District',
    lat: 22.2855,
    long: 114.1577,
  },
  {
    label: 'Eastern District',
    value: 'Eastern District',
    lat: 22.2783,
    long: 114.2367,
  },
  {
    label: 'Southern District',
    value: 'Southern District',
    lat: 22.2461,
    long: 114.1626,
  },
  {
    label: 'Wan Chai District',
    value: 'Wan Chai District',
    lat: 22.2783,
    long: 114.1747,
  },
  {
    label: 'Kowloon City District',
    value: 'Kowloon City District',
    lat: 22.3193,
    long: 114.1954,
  },
  {
    label: 'Kwun Tong District',
    value: 'Kwun Tong District',
    lat: 22.3123,
    long: 114.2267,
  },
  {
    label: 'Sham Shui Po District',
    value: 'Sham Shui Po District',
    lat: 22.3307,
    long: 114.1628,
  },
  {
    label: 'Wong Tai Sin District',
    value: 'Wong Tai Sin District',
    lat: 22.3418,
    long: 114.1918,
  },
  {
    label: 'Yau Tsim Mong District',
    value: 'Yau Tsim Mong District',
    lat: 22.3053,
    long: 114.1694,
  },
  {
    label: 'Islands District',
    value: 'Islands District',
    lat: 22.2587,
    long: 113.9413,
  },
  {
    label: 'Kwai Tsing District',
    value: 'Kwai Tsing District',
    lat: 22.3573,
    long: 114.1276,
  },
  {
    label: 'North District',
    value: 'North District',
    lat: 22.4953,
    long: 114.1481,
  },
  {
    label: 'Sai Kung District',
    value: 'Sai Kung District',
    lat: 22.3814,
    long: 114.2719,
  },
  {
    label: 'Sha Tin District',
    value: 'Sha Tin District',
    lat: 22.3817,
    long: 114.1878,
  },
  {
    label: 'Tai Po District',
    value: 'Tai Po District',
    lat: 22.4507,
    long: 114.1714,
  },
  {
    label: 'Tsuen Wan District',
    value: 'Tsuen Wan District',
    lat: 22.3703,
    long: 114.1137,
  },
  {
    label: 'Tuen Mun District',
    value: 'Tuen Mun District',
    lat: 22.391,
    long: 113.9759,
  },
  {
    label: 'Yuen Long District',
    value: 'Yuen Long District',
    lat: 22.4461,
    long: 114.0178,
  },
];

export const subscriptionPlanStatusOption = [
  {
    label: 'Active',
    value: subscriptionPlanStatus.active,
  },
  {
    label: 'Inactive',
    value: subscriptionPlanStatus.inactive,
  },
];

export const subscriptionPlanPaymentStatusOption = [
  {
    label: 'Pending',
    value: subscriptionPlanPaymentStatus.pending,
  },
  {
    label: 'Waiting for Approval',
    value: subscriptionPlanPaymentStatus.waitingForApproval,
  },
  {
    label: 'Paid',
    value: subscriptionPlanPaymentStatus.paid,
  },
  {
    label: 'Fail',
    value: subscriptionPlanPaymentStatus.fail,
  },
];

export const billingStatusOption = [
  { label: 'Pending', value: billingStatus.pending },
  { label: 'Completed', value: billingStatus.completed },
  { label: 'Failed', value: billingStatus.failed },
  { label: 'Cancelled', value: billingStatus.cancelled },
  { label: 'Voided', value: billingStatus.voided },
];

export const notificationTypeOption = [
  { label: 'Info', value: notificationType.info },
  { label: 'Warning', value: notificationType.warning },
  { label: 'Error', value: notificationType.error },
  { label: 'Success', value: notificationType.success },
];

export const activityLogStatusOption = [
  { label: 'Success', value: activityLogStatus.SUCCESS },
  { label: 'Failed', value: activityLogStatus.FAILED },
];

export const paymentStatusOption = [
  { label: 'Created', value: paymentStatus.CREATED },
  { label: 'Completed', value: paymentStatus.COMPLETED },
  { label: 'Cancelled', value: paymentStatus.CANCELLED },
];

export const tableManagementActivityTypeOption = [
  { value: tableManagementActivityType.watchMovie, text: 'Watch Movie' },
  { value: tableManagementActivityType.sport, text: 'Sport' },
  { value: tableManagementActivityType.eatOrDrink, text: 'Eat or Drink' },
  { value: tableManagementActivityType.other, text: 'Other' },
];

export const billingProductTypeOption = [
  // { value: billingProductType.createFreeTableManagement, label: 'Created Free ' },
  { value: billingProductType.createPaidTableManagement, label: 'Created Paid ' },
  { value: billingProductType.createPremiumTableManagement, label: 'Created Premium ' },
  { value: billingProductType.upgradeTableManagement, label: 'Upgrade Table' },
  { value: billingProductType.unpickApplication, label: 'Unpick Application' },
];

// CRM Options
export const insuranceTypeOptions = [
  { text: '三保', value: insuranceTypes.ThirdParty },
  { text: '全保', value: insuranceTypes.Comp },
  { text: '試車保', value: insuranceTypes.MT },
  { text: '船險', value: insuranceTypes.Ship },
  { text: '火險', value: insuranceTypes.Fire },
  { text: '勞保', value: insuranceTypes.EC },
  { text: '商險', value: insuranceTypes.Business },
];

export const needFileOptions = [
  { text: '牌簙', value: '牌簙' },
  { text: '投保書', value: '投保書' },
];

export const rnTypeOptions = [
  { text: 'RN', value: rnTypes.RN },
  { text: 'No Tel', value: rnTypes.NoTel },
  { text: 'No WhatsApp', value: rnTypes.NoWhatsapp },
  { text: 'Renewed', value: rnTypes.Renewed },
  { text: 'Sold', value: rnTypes.Sold },
  { text: 'Abandoned', value: rnTypes.Abandoned },
  { text: 'Cancelled', value: rnTypes.Cancelled },
  { text: 'Called', value: rnTypes.PhoneCall },
  { text: 'Mailed', value: rnTypes.Mailed },
  { text: 'Non-Renewal', value: rnTypes.NonRenewal },
];

// YOMT Options
export const yomtPaymentMethodOptions = [
  { text: '現金', value: '現金' },
  { text: '轉數快', value: '轉數快' },
  { text: '支票', value: '支票' },
];

export const yomtOthersListOptions = [
  { text: '身份證副本', value: '身份證副本' },
  { text: '公司註冊證副本', value: '公司註冊證副本' },
  { text: '保險單副本', value: '保險單副本' },
  { text: '地址證明副本', value: '地址證明副本' },
  { text: '驗車紙', value: '驗車紙' },
  { text: '行車證', value: '行車證' },
];

export const yomtPaymentRemarkOptions = [
  { key: 'vehicle_reassignment_registration_number', label: '車輛改配登記號碼' },
  { key: 'sold_plate_number', label: '售出車牌號碼' },
  { key: 'cheque_details', label: '支票明細' },
  { key: 'deposit_paid', label: '已支付按金' },
];

// LPMS Options
export const lpmsFileTypeOptions = [
  { text: '留牌紙', value: lpmsFileTypes.retentionCertificate },
  { text: '牌薄', value: lpmsFileTypes.vehicleRegistrationBook },
];

export const lpmsStateOptions = [
  { text: '已續期', value: lpmsState.renewed },
  { text: '已過期', value: lpmsState.expired },
  { text: '售出中', value: lpmsState.selling },
  { text: '已售出', value: lpmsState.sold },
  { text: '辦理中', value: lpmsState.underHandling },
  { text: '放棄出售', value: lpmsState.abandonedToSell },
  { text: '託管', value: lpmsState.custodian },
  { text: '託管出售', value: lpmsState.custodianSelling },
];

// CRM Options SubTypes
export const crmOptionsSubTypesOptions = [
  { text: '保險公司管理', value: crmOptionsSubTypes.insuranceCompany },
  { text: '投保地點管理', value: crmOptionsSubTypes.insuredPlace },
  { text: '代理管理', value: crmOptionsSubTypes.agency },
  { text: '附件管理', value: crmOptionsSubTypes.fileStoragePlace },
];
